import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import { Redirect } from 'react-router';

import GraphQLClient from '../../common/utils/GraphQLClient';
import PlaceholderGenerator from '../../common/components/cms/PlaceholderGenerator';

import ModalProvider from '../../common/components/modal/ModalProvider';
import ModalRoot from '../../common/components/modal/ModalRoot';

import { CareersHeader, CareersFooter } from './components';
import TextPlugin from '../../common/components/cms/TextPlugin';
import { Section, Grid, Cell } from 'formlabs-web-components/Grid';
import {
  Picture,
  FlushPanel,
  Card,
  CompactCard,
  CarouselWrapper,
  Tile,
  TileGroup,
  FullWidthImage
} from 'formlabs-web-components/Media';
import { LargeLink, SuperButton } from 'formlabs-web-components/Link';
import { Callout, Eyebrow } from 'formlabs-web-components/Type';

import {
  CalloutSection,
  HeaderPlugin,
  HeroSection,
  ButtonPlugin,
  YoutubeModal
} from '../../common/components/content';

import { getContent } from '../../common/query';
import NotFound from '../../common/components/errors/NotFound';

import {
  Job,
  CareersTeamsList,
  TeamList,
  LocationTeamsList,
  Employee,
  FeaturedEmployeesSection
} from './components';

import '../../common/styles/global.css';

const componentMap = {
  Grid: Grid,
  Cell: Cell,
  Text: TextPlugin,
  '404': NotFound,
  Picture: Picture,
  FlushPanel: FlushPanel,
  FullCard: Card,
  CompactCard: CompactCard,
  LargeLink: LargeLink,
  HeroSection: HeroSection,
  Tile: Tile,
  TileGroup: TileGroup,
  Section: Section,
  Callout: Callout,
  CalloutSection: CalloutSection,
  SuperButton: SuperButton,
  carousel: CarouselWrapper,
  FullWidthImage: FullWidthImage,
  Header: HeaderPlugin,
  Button: ButtonPlugin,
  Job: Job,
  Eyebrow: Eyebrow,
  CareersTeamsList: CareersTeamsList,
  LocationTeamsList: LocationTeamsList,
  Employee: Employee,
  FeaturedEmployeesSection: FeaturedEmployeesSection,
  TeamList: TeamList,
  YoutubeModal: YoutubeModal
};

class Page extends Component {
  static async getInitialProps({
    req,
    res,
    match,
    draft,
    location,
    isHeadRequest
  }) {
    if (location) {
      // If there's no trailing slash, add one.
      if (!location.pathname.endsWith('/')) {
        const redirectLocation =
          location.pathname.replace(
            location.pathname,
            location.pathname + '/'
          ) +
          location.search +
          location.hash;
        return { redirectLocation };
      }
    }

    const slug = draft
      ? match.params.slug
      : (match.params.slug !== undefined ? '/' + match.params.slug : '') + '/';

    const client = GraphQLClient(req, res);

    const pageData = await client.request(getContent, {
      path: slug,
      draft: draft || false
    });

    let { status, title: page } = await pageData.getContent;

    // Server-side, update status codes and redirect if necessary
    if (res) {
      res.status(status.code);

      if (status.location) {
        res.redirect(status.code, status.location);
      }
    } else {
      // client-side redirect
      if (status.location) {
        const redirectLocation = status.location;
        return { redirectLocation };
      }
      if (!location.pathname.endsWith('/')) {
        const redirectLocation =
          location.pathname.replace(
            location.pathname,
            location.pathname + '/'
          ) +
          location.search +
          location.hash;
        return { redirectLocation };
      }
    }

    return { slug, page, isHeadRequest };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.location && nextProps.location) {
      const isSameLocation =
        this.props.location.pathname === nextProps.location.pathname &&
        this.props.location.search === nextProps.location.search;

      if (isSameLocation) {
        return false;
      }
    }
    return true;
  }

  render() {
    const { page, admin, redirectLocation, isHeadRequest } = this.props;
    if (redirectLocation) {
      return <Redirect to={redirectLocation} />;
    }

    // Short circuit for HEAD request, response needs no body
    if (isHeadRequest) {
      return null;
    }

    return page ? (
      <ModalProvider>
        <Fragment>
          {admin ||
            (page.seo && (
              <Helmet
                {...(page.seo.titlePattern
                  ? { titleTemplate: page.seo.titlePattern }
                  : {})}
              >
                <html lang={page.seo.language} />
                <title>{page.seo.title}</title>
                <meta name="description" content={page.seo.description} />
                <meta name="keywords" content={page.seo.keywords} />
                <link rel="canonical" href={page.seo.canonical} />
                {page.seo.allHrefs &&
                  page.seo.allHrefs.map(x => {
                    return (
                      <link
                        key={x.locale}
                        rel="alternate"
                        href={x.path}
                        hreflang={x.locale}
                      />
                    );
                  })}
              </Helmet>
            ))}
          <CareersHeader />
          <div className="content">
            {page ? (
              <PlaceholderGenerator
                placeholders={page.page.placeholders}
                admin={admin}
                components={componentMap}
              />
            ) : (
              ''
            )}
          </div>
          <CareersFooter />
        </Fragment>
        <ModalRoot />
      </ModalProvider>
    ) : (
      ''
    );
  }
}

export default Page;
